export default "__VITE_ASSET__xy5p0XEa__"